import React from 'react';
import './SideOrders.scss';

function SideOrders() {
    return (
        <div className="sideOrders">
            <div className="sideOrders__bg"></div>
            <div className="sideOrders__card">
                        <div className="sideOrders__info">
                            sour cream
                        </div>
                        <div className="sideOrders__price">$1.50</div>
                </div>
                <div className="sideOrders__card">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="sideOrders__info">
                            guacamole
                        </div>
                        <div className="sideOrders__price">$2.00</div>
                </div>
                <div className="sideOrders__card">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="sideOrders__info">
                            bean & rice
                        </div>
                        <div className="sideOrders__price">$2.00</div>
                </div>
                <div className="sideOrders__card">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="sideOrders__info">
                            jalapenos
                        </div>
                        <div className="sideOrders__price">$1.00</div>
                </div>
                <div className="sideOrders__card">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="sideOrders__info">
                            beans
                        </div>
                        <div className="sideOrders__price">$2.00</div>
                </div>
                <div className="sideOrders__card">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="sideOrders__info">
                            rice
                        </div>
                        <div className="sideOrders__price">$2.00</div>
                </div>
                <div className="sideOrders__card">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="sideOrders__info">
                            flour tortilla with butter
                        </div>
                        <div className="sideOrders__price">$1.39</div>
                </div>
                <div className="sideOrders__card">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="sideOrders__info">
                            extra cheese
                        </div>
                        <div className="sideOrders__price">$1.00</div>
                </div>
                <div className="sideOrders__card">
                        {/* <div className="menu__bg">
                        </div> */}
                        <div className="sideOrders__info">
                            flour tortilla(single)
                        </div>
                        <div className="sideOrders__price">$1.00</div>
                </div>
        </div>
    )
}

export default SideOrders
